module.exports = __webpack_public_path__ + "img/ResumeTemp7.7b1ec793.png";